// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"temple"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5 21V10H19V21H5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M5 10L12 3L19 10H12H5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 10L12 3L19 10M5 10V21M5 10H4M5 10H12M19 10V21M19 10H12M19 10H20M5 21H3M5 21H12M19 21H21M19 21H12M12 10V21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TempleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'temple',
    ref,
    icon: element,
  },
));

TempleIcon.displayName = 'TempleIcon';

export default TempleIcon;
